"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PEPComponent2 = _interopRequireDefault(require("./utils/PEPComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PEP = /*#__PURE__*/function (_PEPComponent) {
  _inherits(PEP, _PEPComponent);

  var _super = _createSuper(PEP);

  /**
   * @typedef PEPData
   * @property {PIMData} hearingInstruments
   * @property {PEPFilter[]} hearingInstrumentFilters
   * @property {PIMData} accessories
   * @property {PEPFilter[]} accessoriesFilters
   * @property {PIMData} productDetails
   * @property {PIMData} styles
   */

  /**
   * Multipurpose component. Encompases all features of the more specific components. Only use if the other PEPComponent subclasses fall short of your needs.
   * @param {string} [selector=pep]
   * @constructor
   * @augments PEPComponent
   * @inheritdoc
   */
  function PEP() {
    var _this;

    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pep';

    _classCallCheck(this, PEP);

    _this = _super.call(this, selector);
    /**
     * @type {PEPComponent~resolveProductId}
     */

    _this.onResolveProductId = function (component) {
      return '';
    }; // eslint-disable-line no-unused-vars

    /**
     * @type {boolean}
     */


    _this.fetchHearingInstruments = false;
    /**
     * @type {boolean}
     */

    _this.fetchAccessories = false;
    /**
     * @type {boolean}
     */

    _this.fetchProductDetails = false;
    /**
     * @type {boolean}
     */

    _this.fetchStyles = false;
    /**
     * @callback PEP~renderCallback
     * @param {object} response
     * @param {HTMLElement} response.component The the current instance of the component
     * @param {PIM} response.pimInstance The global PIM instance used for loading data
     * @param {Promise<PEPData|Error>} response.dataPromise A promise for the data being loaded.
     * @param {PEPFilter[]} response.filters An array of filters configured for component
     * @param {PEPConfig} response.config The full configuration parsed for the component
     * @param {PEPLabels} response.labels An instance of PEPLabels used for retrieving labels for the ui.
     */

    /**
     * @type {PEP~renderCallback}
     */

    _this.onRender = null;
    return _this;
  }

  _createClass(PEP, [{
    key: "fetchData",
    value: function fetchData(pim, component) {
      var _this2 = this;

      var promises = [];
      promises.push(this.fetchHearingInstruments ? this.doFetchHearingInstruments(pim) : this.fetchNull());
      promises.push(this.fetchAccessories ? this.doFetchAccessories(pim) : this.fetchNull());
      promises.push(this.fetchProductDetails ? this.doFetchProductDetails(pim, this.onResolveProductId(component)) : this.fetchNull());
      promises.push(this.fetchStyles ? this.doFetchStyles(pim) : this.fetchNull());
      return Promise.all(promises).then(function (values) {
        /**
         * @type {PEPData}
         */
        var pepData = {
          hearingInstruments: values.length > 0 ? values[0] : null,
          hearingInstrumentFilters: _this2.config.getHearingInstrumentFilters(),
          accessories: values.length > 1 ? values[1] : null,
          accessoriesFilters: _this2.config.getAccessoriesFilters(),
          productDetails: values.length > 2 ? values[2] : null,
          styles: values.length > 3 ? values[3] : null
        };

        if (pepData.hearingInstruments) {
          _this2.createFilters(pepData.hearingInstruments, pepData.hearingInstrumentFilters);
        }

        if (pepData.accessories) {
          _this2.createFilters(pepData.accessories, pepData.accessoriesFilters);
        }

        return pepData;
      });
    }
    /**
     *
     * @param {PIM} pim
     * @private
     */

  }, {
    key: "doFetchHearingInstruments",
    value: function doFetchHearingInstruments(pim) {
      return pim.fetchHearingInstruments();
    }
    /**
     *
     * @param {PIM} pim
     * @private
     */

  }, {
    key: "doFetchAccessories",
    value: function doFetchAccessories(pim) {
      return pim.fetchAccessories();
    }
    /**
     *
     * @param {PIM} pim
     * @private
     */

  }, {
    key: "doFetchProductDetails",
    value: function doFetchProductDetails(pim, productId) {
      return pim.fetchProduct(productId);
    }
    /**
     * @param {PIM} pim
     * @private
     */

  }, {
    key: "doFetchStyles",
    value: function doFetchStyles(pim) {
      return pim.fetchStyles();
    }
  }, {
    key: "fetchNull",
    value: function fetchNull() {
      return new Promise(function (resolve) {
        resolve(null);
      });
    }
  }]);

  return PEP;
}(_PEPComponent2["default"]);

var _default = PEP;
exports["default"] = _default;